<template>
  <ApprovalConfirmation v-if="ApprovalListchange.length != 0 &&
    ApprovalListchange.some(item => item['IsApproved'] == 0) && Number(QueryStringValue?.IsApproval) !== 1
  " :approvaldata="ApprovalListchange" :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()"
    @Approve="Approve" :SuccessfullPopUp="SuccessfullPopUp" />
  <ApprovalStatus v-if="ApprovalList.length != 0 && Number(QueryStringValue?.IsApproval) !== 1"
    :ApprovalgetList="ApprovalList" :approvaldetails="approvaldetails" />
  <div class="overall-bg pt-4 pb-0">
    <b-container>
      <b-row>
        <b-col>
          <BacktoPage :goback="$router.back" v-if="Number(QueryStringValue?.IsApproval) !== 1"></BacktoPage>
          <Headerlayout headertext="GRN Details" contenttext=""></Headerlayout>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <b-container class="form-white-bg">
    <div>
      <b-row v-if="loading" class="pt-3">
        <b-col sm="6" cols="12">
          <Skeleton width="12rem" />
        </b-col>
        <b-col sm="6" cols="12">
          <Skeleton height="2rem" width="7rem" class="float-end" />
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col xl="6" md="6" sm="6" cols="12" class="py-3">
          <p class="light-txt">{{ SummaryName }} Summary</p>
        </b-col>
        <b-col xl="6" md="6" sm="6" cols="12" class="py-3">
          <di class="float-end d-flex align-items-center gap-3">
            <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print" />
            <Button label="Barcode print" severity="info" icon="pi pi-print" class="printbtn barcodeprintbtn ms-2"
              @click="BarcodePrint" />

          </di>
        </b-col>
      </b-row>
      <b-row v-if="loading" class="pt-3">
        <b-row>
          <b-col xl="4" lg="3" sm="4" md="6" cols="12">
            <MobileLoader />
          </b-col>
        </b-row>
      </b-row>
      <b-row class="px-3" v-else>
        <b-col lg="4" xl="4" xxl="4" md="8" sm="8">
          <Card class="summarycard">
            <template #title>
              <b-row>
                <b-col>
                  <p class="card-font">{{ details.Grn }}</p>
                  <p class="card-font">
                    <span><i class="pi pi-calendar"></i>{{
                      details.Grndate
                    }}
                      <!-- getConvertedDate(details.Grndate, "DD MM YYYY | h:mmA") -->

                    </span>
                  </p>
                </b-col>
                <b-col class="d-flex flex-row-reverse card-font">
                  <p>₹ {{ details.NetAmount }}</p>
                </b-col>
              </b-row>
            </template>
            <template #content>
              <b-row>
                <b-col>
                  <h6 class="mb-2">Supplier Information</h6>
                  <div class="d-flex">
                    <p class="me-3">Name:</p>
                    <p>
                      {{ details.SupplierName }}
                    </p>
                  </div>
                  <div class="d-flex my-2">
                    <p class="me-3">Address:</p>
                    <p>
                      {{ details.Address }}
                    </p>
                  </div>

                  <div class="d-flex my-2">
                    <p class="me-3">GST:</p>
                    <p>
                      {{ details.GST }}
                    </p>
                  </div>
                </b-col>

              </b-row>
              <b-row>
                <b-col>
                  <h6>PAYMENT TERMS</h6>
                  <p>
                    {{ details.Paymentterms }}
                  </p>
                </b-col>
                <b-col>
                  <h6>DELIVERY TERMS</h6>
                  <p>{{ details.deliveryterms }}</p>
                </b-col>
              </b-row>
            </template>
          </Card>
        </b-col>
      </b-row>
      <div class='field ' v-if="uploadedTableList.length != 0">
        <label class=" mt-0">{{ $t("PurchaseRequest.QuotationFile") }}</label>
      </div>
      <b-row>
        <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
          <div class="fileuploadcard my-2" :title="item.fileName">
            <div>
              <p class="filenametxt">{{ item.fileName }}</p>
              <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                view </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4">

        <b-col>
          <div class="field">
            <TextField name="Transportation Charges" :label="$t('grn.transportationcharges')"
              :rules="{ required: false, decimal: true }" id="Transportation Charges"
              v-model="POCalcDetails.GRNTransportationCharges" disabled />
          </div>
        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Transportation Tax" :label="$t('grn.transportationtax')"
              :rules="{ required: false, decimal: true, percentage: true }" id="Transportation Tax"
              v-model="POCalcDetails.GRNTransportationTax" disabled />
          </div>
        </b-col>

        <b-col>
          <div class="field">
            <TextField name="Freight Charges" :label="$t('grn.freightcharges')"
              :rules="{ required: false, decimal: true }" id="Freight Charges" v-model="POCalcDetails.GRNFreightCharges"
              disabled />
          </div>
        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Freight Tax" :label="$t('grn.freighttax')"
              :rules="{ required: false, decimal: true, percentage: true }" id="Transportation Tax" disabled
              v-model="POCalcDetails.GRNFreightTax" />
          </div>
        </b-col>

        <b-col>
          <div class="field">
            <TextField name="Other Charges" :label="$t('grn.othercharges')" :rules="{ required: false, decimal: true }"
              id="Other Charges" v-model="POCalcDetails.GRNOtherCharges" disabled />
          </div>
        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Discount" :label="$t('grn.discountamount')" :rules="{ required: false, decimal: true }"
              id="Discount" v-model="POCalcDetails.GRNDiscount" disabled />
          </div>
        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Roundoff" :label="$t('grn.roundoff')" v-model="POCalcDetails.RoundOff"
              :rules="{ required: false, alphabet: false }" id="Roundoff" disabled />
          </div>
        </b-col>
      </b-row>
      <!-- <b-row class="px-3 pt-5">
        <b-col>
          <p class="light-txt">{{ SummaryName }} Details</p>
        </b-col>
      </b-row> -->
    </div>
  </b-container>
  <b-container class="form-white-bg pt-0">
    <!-- {{ List }} -->
    <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines" :rows="10"
      :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
      :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" :serialNumber="true">>
      <template v-slot:combinedFieldSlot="{ data }">
        <p v-if="data.BrandName == null && data.ModelNumberName == null && data.SizeName == null">
          {{ "-" }}
        </p>
        <p v-else>
          {{ data.BrandName != null ? data.BrandName : "-" }} /
          {{ data.ModelNumberName != null ? data.ModelNumberName : "-" }} /
          {{ data.SizeName != null ? data.SizeName : "-" }}
        </P>
      </template>

      <template v-slot:Itemname1="{ data, rowIndex }">
        <div v-if="data.IsFreeItem == '1'">
          <span :style="getPromoColorStyle(data)">
            {{ data.Itemname1 }} - (Promo)
          </span>
        </div>
        <div v-else-if="data.IsFreeQtyItem == '1'">
          <span :style="getFreeQtyColorStyle(data)">
            {{ data.Itemname1 }} - (Free)
          </span>
        </div>
        <p v-else>
          {{ data.Itemname1 }}
        </p>
      </template>

      <template v-slot:ExpiryDate="{ data }">
        <div
          v-if="data.ExpiryDate && data.ExpiryDate !== '01-01-0001' && data.ExpiryDate !== '01-01-1900' && data.ExpiryDate !== '-'"
          :style="getExpiryDateStyle(data.ExpiryDate)">
          {{ data.ExpiryDate }}
          <div class="expiry-message">{{ getExpiryMessage(data.ExpiryDate) }}</div>
        </div>
        <div v-else>
          {{ data.ExpiryDate || '-' }}
        </div>
      </template>

    </Tableview>

    <b-row>
      <b-col lg="8" md="8">
      </b-col>
      <b-col lg="4" md="4">
        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              Gross Amount
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.GrossAmount }}
            </p>
          </b-col>

        </b-row>

        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              Discount Amount
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.DiscountAmount }}
            </p>
          </b-col>

        </b-row>

        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              Tax Amount
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.TaxAmount }}
            </p>
          </b-col>

        </b-row>

        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              SGST Amount
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.SGSTTaxAmount }}
            </p>
          </b-col>

        </b-row>

        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              CGST Amount
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.CGSTTaxAmount }}
            </p>
          </b-col>

        </b-row>

        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              IGST Amount
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.IGSTTaxAmount }}
            </p>
          </b-col>

        </b-row>

        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              Transport charges
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.Transportcharges }}
            </p>
          </b-col>

        </b-row>
        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              Freight charges
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.Freightcharges }}
            </p>
          </b-col>

        </b-row>
        <b-row>
          <b-col class="ammount_footer">
            <p class="light-txt">
              Service charges
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.Servicecharges }}
            </p>
          </b-col>

        </b-row>
        <b-row class="my-3">
          <b-col class="ammount_footer">
            <p class="light-txt">
              Other charges
            </p>
            <p>
              <span class="pe-1">&#8377</span>
              {{ POCalcDetails.Othercharges }}
            </p>
          </b-col>

        </b-row>

        <b-row>
          <b-col class="d-flex align-items-center mt-5">
            <p>
              Grand Total
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col offset-lg="3" class="d-flex px-0">
            <div class="totaldiv1">
              <p class="component-heading">{{ POCalcDetails.ItemCount }}</p>

              <p class="light-txt">Items Part of this GRN</p>
            </div>
            <div class="totaldiv2">
              <p class="component-heading"><span class="pe-1">&#8377</span>{{ POCalcDetails.TotalAmount }}</p>
              <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
  <Toast />

  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />

</template>

<script lang="ts">
import { defineComponent, ref, Ref, onMounted, watch, computed } from "vue";
import LeftBar from "../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import Log from "../../../../../../modules/Inventory/components/Sidebar/RightSidebar/UserDetailsRightSidebar.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import commonService from "../../../../../../modules/Inventory/Service/StockInService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import service from "../../../../../../modules/Inventory/Service/SupplierMaster";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import moment from "moment";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useToast } from "primevue/usetoast";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import { useI18n } from 'vue-i18n';
import PoApprovalService from "../../../../../../modules/Inventory/Service/PoApprovalService";
import ApprovalConfirmation from "../../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../../components/FormComponents/ApprovalStatus.vue";
import StockInFileUploadServices from "../../../../../../modules/Inventory/Service/StockInFileUploadService";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    LeftBar,
    Details,
    Log,
    BacktoPage,
    Headerlayout,
    Loader,
    MobileLoader,
    Tableview,
    TextField,
    ApprovalConfirmation,
    ApprovalStatus,
    CrystalReportPrintPopUp

  },

  props: {
    Operations: {
      type: Object,
      default: () => ({}),
    },
    ApprovalObj: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    let Id = ref([]);
    const router = useRouter();
    const routes = useRoute();

    const menu = ref();
    let loading = ref(false);
    let SummaryName = ref("");
    let List = ref([]);
    let loading1 = ref(false);

    // get local storage values
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const route = useRoute();

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    let QueryStringValue = ref(route.query);

    watch(
      () => [props.Operations, props.ApprovalObj],
      ([newOperations, newApprovalObj]) => {
        debugger;
        if (newOperations.Id) {
          QueryStringValue.value = newOperations;
        }

        if (newApprovalObj.Status) {
          UpdateApprovalStatus(newApprovalObj.Status);
        }
      },
      { immediate: true, deep: true }
    );

    const POCalcDetails = ref({
      GrossAmount: 0.00,
      TaxAmount: 0.00,
      SGSTTaxAmount: 0.00,
      CGSTTaxAmount: 0.00,
      IGSTTaxAmount: 0.00,
      Transportcharges: 0.00,
      Freightcharges: 0.00,
      Servicecharges: 0.00,
      Othercharges: 0.00,
      DiscountAmount: 0.00,
      ItemCount: 0,
      TotalAmount: 0.00,
      RoundOff: ref(),


      GRNTransportationCharges: "0.0",
      GRNOtherCharges: "0.0",
      GRNDiscount: "0.0",
      DCType: ref(),
      GRNTransportationTax: "0.0",
      GRNFreightCharges: "0.0",
      GRNFreightTax: "0.0",
    })

    let details: any = ref({
      SupplierId: 0,
      NetAmount: "",
      Grndate: "",
      Paymentterms: "",
      DeliveryTerms: "",
      Grn: "",
      RefNo: "",
      SupplierName: "",
      Address: "",
      suppliername: "",
      GST: "",
      DocType: "",
      StoreId: 0,
      Grnstatus: 0,
      CreatedAt: "",
      Email: "",
      EntityId: 0
    });

    const headers = computed(() => [
      {
        header: t('storetabdetails.grndetails.Code'),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft1"
      },
      {
        header: t('storetabdetails.grndetails.Name'),
        field: "Itemname1",
        slot: "Itemname1",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft2",
      },
      {
        header: t('storetabdetails.grndetails.Brand/ModelNumber/Size'),
        field: "BrandName",
        slot: "combinedFieldSlot",
        fieldDisplay: "false",
        class: "newcolumnfreezeleft3"
      },
      {
        header: t('storetabdetails.grndetails.Qty'),
        field: "ItemQuantity",
        slot: "Qty",
        sortable: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.FreeQty'),
        field: "FreeQty",
        slot: "FreeQty",
        sortable: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.GRNQty'),
        field: "GRNQty",
        slot: "GRNQty",
        sortable: false,
        bodyclass: "right_td",
        class: QueryStringValue.value.DocType == "19" ? "smallwidth" : "d-none",
      },
      {
        header: t('storetabdetails.grndetails.ManufactureDate'),
        field: "ManufactureDate",
        sortable: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t('storetabdetails.grndetails.ExpiryDate'),
        field: "ExpiryDate",
        slot: "ExpiryDate",
        sortable: false,
        class: "smallwidth newcolumnfreezeleft4",
        bodyclass: "right_td",
        fieldDisplay: "false",

      },
      {
        header: t('storetabdetails.grndetails.UOM'),
        field: "SalesUnitName",
        class: "smallwidth"
      },

      {
        header: t('storetabdetails.grndetails.HSN'),
        field: "HSNManualCode",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.BatchNo'),
        field: "BatchNo",
        slot: "BatchNo",
        sortable: false,
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.PurchasingUnit'),
        field: "PurchaseUnitName",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.UnitRate'),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.ServiceCharges'),
        field: "servicecharges",
        slot: "servicecharges",
        sortable: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.OtherCharges'),
        field: "othercharges",
        slot: "othercharges",
        sortable: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.Tax%'),
        field: "PurchasePercentage",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.Tax'),
        field: "Purchasetaxamount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.SGST%'),
        field: "SGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.SGST'),
        field: "SGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.CGST%'),
        field: "CGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.CGST'),
        field: "CGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.IGST%'),
        field: "IGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.IGST'),
        field: "IGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.Discount%'),
        field: "Discount",
        slot: "Discount",
        sortable: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.Discount'),
        field: "Discountamount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.Total'),
        field: "Totalvalue",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.MRP'),
        field: "MRP",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grndetails.BinLocation'),
        field: "BinLocation",
        slot: "combinedBin"
      },
    ]);


    const globalFilterFields = ref(headers.value.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      HSNName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ManufactureName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      UnitName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemCategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemSubGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGenericName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);

    let approvaldetails: any = ref({
      HeaderName: "GRN",
      ContentName: "GRN",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });
    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });
    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0
    });
    let uploadedTableList: any = ref([])
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }
    onMounted(async () => {
      await Grndetails();
      if (Number(QueryStringValue.value.IsApproval) !== 1) {
        getApprovaldata();
      }
    });

    const Grndetails = async () => {
      try {
        debugger;
        loading.value = true;
        const response = await commonService.getlistById(QueryStringValue.value.Id);
        debugger
        let data = response["result"][0];
        List.value = response["result"].map((item) => {
          if (item.ExpiryDate == "01-01-1900") {
            item.ExpiryDate = ""
          }

          if (item.ManufactureDate == "01-01-1900") {
            item.ManufactureDate = ""
          }

          return item
        }
        )
        console.log(data);
        details.value.NetAmount = data.netamount;
        details.value.SupplierId = data.SupplierId;
        details.value.Grndate = data.DocDate;
        details.value.Grn = data.DocNo;
        details.value.RefNo = data.RefNo;
        details.value.CreatedAt = data.CreatedAt;
        details.value.DocType = data.DocType;
        details.value.StoreId = data.StoreId;
        details.value.Grnstatus = data.Status;
        details.value.EntityId = data.EntityId;
        approvaldetails.value.ApprovalCode = data.DocNo;
        approvaldetails.value.ApprovalDate = data.DocDateHR;
        approvaldetails.value.CreatedAt = data.CreatedAt;

        approvaldetails.value.ApprovalPrice = data.netamount;
        const FileUploadresult = await StockInFileUploadServices.getStockInFileById(
          QueryStringValue.value.Id
        );
        if (FileUploadresult['result'].length > 0) {
          for (let i = 0; i < FileUploadresult['result'].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
              (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
              (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
              (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
              (Fileobj["Id"] = FileUploadresult['result'][i].Id),
              uploadedTableList.value.push(Fileobj)
          }
        }
        else {
          uploadedTableList.value = [];
        }
        if (details.value.DocType == "7" || details.value.DocType == "8") {
          SummaryName.value = "GRN";
        } else if (details.value.DocType == "19") {
          SummaryName.value = "Delivery Chellon";
        } else {
          console.log(details.value.DocType);
        }
        getfindonedata();
        loading.value = false;
      } catch (error) {
        alert(error);
      }
    };
    async function Approve(Values) {
      debugger;
      try {
        let rowToAssign = null;
        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break; // Exit the loop once the first matching row is found
          }
        }
        if (rowToAssign) {
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];
          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
          isForm.value.EntityId = details.value.EntityId;
        }
        let response;
        if (isForm.value.IsApproved == 1) {
          response = await PoApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1 || response["result"] == 2) {
              UpdateApprovalStatus(1);
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await PoApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus(isForm.value.IsApproved);
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function UpdateApprovalStatus(status) {
      debugger;
      try {
        const response = await commonService.UpdateApprovalStatus(
          // ApprovalListchange.value[0]["EntityTransactionId"],
          QueryStringValue.value.Id,
          status
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function getApprovaldata() {
      debugger;
      try {
        let response = await PoApprovalService.GetPOApprovalList(
          QueryStringValue.value.Id,
          usersData.OrganizationId,
          QueryStringValue.value.BranchId,
          QueryStringValue.value.EntityId
        );

        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"].filter(
          (item) => item.DepRoleID == rolesData.DeptRoleMapId
        );
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    }

    async function getfindonedata() {
      try {
        let response = await service.EditData(details.value.SupplierId);
        debugger;
        const data1 = response["result"][0];
        console.log(data1);
        debugger;
        details.value.SupplierName = data1.Name;
        details.value.Address = data1.Address;
        details.value.GST = data1.GSTNO;
        details.value.Email = data1.Email;
        details.value.Paymentterms = data1.PaymentTermsDesc;
        details.value.deliveryterms = data1.DeliTermsDesc;
      } catch (error) {
        console.log(error);
      }
    }
    const convertedDate = ref("");
    const getConvertedDate = (dateString, format) => {
      if (dateString!) {
        alert(dateString)
        convertedDate.value = moment(dateString).format(format);
        return convertedDate.value;
      }
    };
    watch(List, (newItems, oldItems) => {
      debugger;
      pocalculation();
    }, { deep: true });
    const pocalculation = () => {
      debugger;
      POCalcDetailsClear()
      for (let i = 0; i < List.value.length; i++) {
        if (List.value[i]["IsFreeItem"] != 1) {
          POCalcDetails.value.GrossAmount += List.value[i]["Rate"];
          // POCalcDetails.value.TaxAmount += List.value[i]["Purchasetaxamount"];
          POCalcDetails.value.TaxAmount += parseFloat(Number(List.value[i]["Purchasetaxamount"]).toFixed(2));
          POCalcDetails.value.SGSTTaxAmount += List.value[i]["SGSTTaxAmount"];
          POCalcDetails.value.CGSTTaxAmount += List.value[i]["CGSTTaxAmount"];
          POCalcDetails.value.IGSTTaxAmount += List.value[i]["IGSTTaxAmount"];
        }

      }
      POCalcDetails.value.Transportcharges = List.value[0]["totaltransportcharges"]
      POCalcDetails.value.Freightcharges = List.value[0]["GRNFreightCharges"]
      POCalcDetails.value.Servicecharges = List.value[0]["totalservicecharges"]
      POCalcDetails.value.Othercharges = List.value[0]["totalothercharges"]
      POCalcDetails.value.DiscountAmount = List.value[0]["totaldiscountamount"]
      POCalcDetails.value.RoundOff = List.value[0]["RoundOff"]



      POCalcDetails.value.GRNTransportationCharges = List.value[0]['totaltransportcharges'];
      POCalcDetails.value.GRNFreightCharges = List.value[0]['GRNFreightCharges'];
      POCalcDetails.value.GRNOtherCharges = List.value[0]['totalothercharges']
      POCalcDetails.value.GRNDiscount = List.value[0]['GRNDiscount'];


      poSubcalculation()
    };

    const poSubcalculation = () => {
      debugger;
      POCalcDetails.value.ItemCount = List.value.length;
      POCalcDetails.value.TotalAmount = Number(((Number(POCalcDetails.value.GrossAmount) + Number(POCalcDetails.value.TaxAmount) + Number(POCalcDetails.value.Transportcharges) + Number(POCalcDetails.value.Freightcharges) + Number(POCalcDetails.value.Servicecharges) + Number(POCalcDetails.value.Othercharges) + Number(POCalcDetails.value.RoundOff)) - Number(POCalcDetails.value.DiscountAmount)).toFixed(2));
    }

    function POCalcDetailsClear() {
      debugger;
      POCalcDetails.value.GrossAmount = 0.00;
      POCalcDetails.value.TaxAmount = 0.00;
      POCalcDetails.value.SGSTTaxAmount = 0.00;
      POCalcDetails.value.CGSTTaxAmount = 0.00;
      POCalcDetails.value.IGSTTaxAmount = 0.00;
      POCalcDetails.value.ItemCount = 0;
      POCalcDetails.value.TotalAmount = 0.00;
      POCalcDetails.value.RoundOff = '';
    }

    function getExpiryDateStyle(expiryDate: string) {
      if (!expiryDate || expiryDate === '01-01-0001' || expiryDate === '01-01-1900' || expiryDate === '-') {
        return {};
      }

      try {
        const [day, month, year] = expiryDate.split('-').map(Number);
        const expiry = new Date(year, month - 1, day);
        const today = new Date();
        const diffTime = expiry.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
          return { color: '#dc3545', fontWeight: 'bold' }; // Red for expired
        } else if (diffDays <= 90) {
          return { color: '#fd7e14', fontWeight: 'bold' }; // Orange for within 90 days
        }
        return {};
      } catch (error) {
        return {};
      }
    }

    function getExpiryMessage(expiryDate: string) {
      if (!expiryDate || expiryDate === '01-01-0001' || expiryDate === '01-01-1900' || expiryDate === '-') {
        return '';
      }

      try {
        const [day, month, year] = expiryDate.split('-').map(Number);
        const expiry = new Date(year, month - 1, day);
        const today = new Date();
        const diffTime = expiry.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
          return `Expired ${Math.abs(diffDays)} days ago`;
        } else if (diffDays <= 90) {
          return `Expires in ${diffDays} days`;
        }
        return '';
      } catch (error) {
        return '';
      }
    }

    function getPromoColorStyle(data) {
      return data.IsFreeItem ? { color: "Red" } : {};
    }

    function getFreeQtyColorStyle(data) {
      return data.IsFreeQtyItem ? { color: "green" } : {};
    }

    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 2,
      HeaderTitle: "GRN",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Number(QueryStringValue.value.Id);
      ParameterValues.value.BranchId = Number(QueryStringValue.value.BranchId);
      ParameterValues.value.HospitalId = usersData.OrganizationId;
      PrintType.value.FormId = 2;
    }

    function BarcodePrint() {
      debugger;

      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Number(QueryStringValue.value.Id);
      ParameterValues.value.BranchId = Number(QueryStringValue.value.BranchId);
      ParameterValues.value.HospitalId = usersData.OrganizationId;
      PrintType.value.FormId = 106;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    return {
      getExpiryDateStyle,
      getExpiryMessage,
      getPromoColorStyle,
      getConvertedDate,
      details,
      menu,
      Id,
      loading,
      SummaryName,
      headers,
      globalFilterFields,
      filters,
      loading1,
      List,
      POCalcDetails,
      ApprovalList,
      ApprovalListchange,
      approvaldetails,
      Approve,
      getApprovaldata,
      SuccessfullPopUp,

      QueryStringValue,
      fileviewer,
      uploadedTableList,
      getFreeQtyColorStyle,
      Print,
      hidepopup,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
      BarcodePrint
    };
  },
});
</script>

<style lang="scss" scoped>
.expiry-message {
  font-size: 0.75rem;
  font-style: italic;
  margin-top: 2px;
}

.col-xl-2 {
  width: 19.666667%;
}

.barcodeprintbtn {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.col-xl-10 {
  width: 80.333333%;
}

.sidebar-static-header {
  padding: 15px 15px 20px 45px;
  font-weight: 600;
  border-bottom: 5px solid #f8f9fe;
  position: sticky;
  left: 0px;
  top: 0px;
  background-color: #f8f9fe;
  z-index: 1;
}

.other-tabs {
  height: 90vh;
  padding-left: 5px !important;
  overflow: auto;
}

.overall-bg {
  section {
    width: 100%;
    overflow: hidden;
  }
}

.leftsidebar {
  position: relative;
  padding-right: 0px !important;
}

.back-btn {
  background-color: #0148e2;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  position: absolute;
  top: 20px;
  right: -12px;
  z-index: 1000;

  .back {
    width: 20px;
    position: absolute;
    top: -45px;
    left: 8px;
  }
}

.count-shows {
  font-weight: 300;
  padding-bottom: 10px;
}

.card-font {
  font-size: small;
}

.Actionsbtn {
  background-color: #4a8fe9 !important;
  border: none !important;
  padding: 8px !important;
}

.overall-bg {
  background-color: #f8f9fe;
  padding: 0;
  height: auto;
}

.header-top {
  margin-top: 0px !important;
}

.steps .p-tabview-header {
  width: 20% !important;
}

.steps .p-tabview-header-action {
  justify-content: center !important;
}

.Tabheading {
  font-size: small;
}

.summarycard {
  font-size: small !important;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none !important;
}

.pi-check-circle {
  color: green;
  letter-spacing: 7px;
}

.sidebar-det-list {
  color: black !important;
}

.width80 {
  width: 80%;
}

@media only screen and (max-width: 1024px) {
  .width80 {
    width: 100%;
  }
}
</style>
